import { connect } from 'react-redux';

import { getIsCreating, getIsCreated } from 'src/reducers/reports/reportWageLedger';
import LeftAction from '../components/LeftAction';

function mapStateToProps(state) {
  return {
    isCreating: getIsCreating(state),
    isCreated: getIsCreated(state)
  };
}

export default connect(mapStateToProps, null)(LeftAction);
